import * as React from "react";
import { SVGProps } from "react";

const Elongate = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    id="Layer_1"
    x={0}
    y={0}
    viewBox="0 0 127 108"
    {...props}
  >
    <style>{".st0{fill:#00baff}"}</style>
    <path
      d="m127.4 46.8-9-9-9-9-9-9-19.1 19.1v17.9l19.1-19.1 9 9.1-28.1 28.1-3.3 3.3V20.6l3.3-3.3L89.6 9 81.3.6l-.6-.6L78 2.7 65.3 15.3v93.5L78 96.1l3.3-3.3 37.1-37.1 9-8.9zm-98.9-9.1 19.1 19.1V38.9L28.5 19.8l-8.9 9z"
      className="st0"
    />
    <path
      d="m46.7 0-.6.6L37.8 9l8.3 8.3 3.3 3.3v57.6l-3.3-3.3L18 46.8l-9-9-9 9 9 8.9 37.1 37.1 3.3 3.3 12.7 12.7V15.3L49.4 2.7z"
      className="st0"
    />
  </svg>
);

export default Elongate;
